import { __assign } from "tslib";
export function initialState(defaultSelected) {
    return {
        activeSteps: new Set(defaultSelected),
    };
}
export function reducer(state, action) {
    if (action.type === 'activate-step') {
        var update = action.payload.solo ? new Set([action.payload.id]) : state.activeSteps.add(action.payload.id);
        return __assign(__assign({}, state), { activeSteps: update });
    }
    if (action.type === 'deactivate-step') {
        state.activeSteps.delete(action.payload);
        return __assign(__assign({}, state), { activeSteps: state.activeSteps });
    }
    return state;
}
